/**
 * Tealium連携用グローバル変数ApiReplyOutputのAPIレスポンス変数名生成
 *
 * @param url パス
 * @param method HTTPメソッド
 * @param res レスポンス
 * @returns
 */
export function createResponseName(url: string, method: string, res: any): string {
  // APIリクエストURLの最後の相対パスを取得し、「"-"除外したパスのキャメルケース + "Reply"」 をAPIレスポンス変数名とする
  //   例）/get-orderの場合、「getOrderReply」をAPIレスポンス変数名とする
  // グローバル変数ApiReplyOutputに既に該当変数名が存在する場合（同じAPI複数回リクエストがあった場合）、「xxxReply-n」をAPIレスポンス変数名とする
  //   例）/get-order複数回callされた場合、「getOrderReply」→「getOrderReply-1」→「getOrderReply-2」... をAPIレスポンス変数名とする
  const reqArr = url.split('/');
  let replyName = reqArr[reqArr.length - 1];
  if (replyName.indexOf('-') > 0) {
    const replayNameArr = replyName.split('-');
    replyName = replayNameArr
      .map((val, index) => (index === 0 ? val : `${val.charAt(0).toUpperCase()}${val.slice(1)}`))
      .join('');
  }
  const replyAswName = `${replyName}Reply`;
  if (!(window as any).Asw.ApiReplyOutput[replyAswName]) {
    return replyAswName;
  }
  const apiReplyOutputKeyArray = Object.keys((window as any).Asw.ApiReplyOutput);
  if (apiReplyOutputKeyArray.length === 0) {
    return replyAswName;
  } else {
    const replyNumber = apiReplyOutputKeyArray.filter((reply) => {
      return reply.includes(replyAswName);
    }).length;
    return replyNumber === 0 ? replyAswName : `${replyName}Reply-${replyNumber}`;
  }
}
